<template>
  <div class="viewContainer csv">
    <button v-if="currentStep > 2" class="scroll-down-btn" @click="scrollToBottom">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3" />
      </svg>
    </button>
    <h1>Bestand updaten</h1>
    <StepNavigation :step="currentStep" :stepTitles="stepTitles" />
    <div class="step0">
      <b-row v-if="currentStep === 0" style="height: 500px;">
        <b-col>
          <h2 class="v2">Datei auswählen</h2>
          <input ref="fileInput" type="file" @change="readFile" class="d-none" />
          <button class="btn btn-primary" @click="$refs.fileInput.click()">Datei auswählen</button>
          <b-row v-if="fileName.length > 0 && csvColumns.length > 0">
            <b-alert class="updater" fade variant="success" :show=showAlert>
              Datei "{{ fileName }}" erfolgreich hochgeladen, {{ csvInput.length }} Zeilen gefunden.
            </b-alert>
          </b-row>
          <ButtonFooter :backButtonVisible="false" :okButtonDisabled="fileName.length === 0 || csvColumns.length === 0"
            :okButtonLabel="this.$t('general.buttons.forward')" :okAction="() => { currentStep += 1 }" />
        </b-col>
      </b-row>
    </div>
    <div class="step1">

      <b-row v-if="currentStep === 1">
        <b-col>
          <h2 class="v2">{{ this.$t('updater.step1') }}</h2>
          <TargetMapping :csvColumns="csvColumns" 
            :finishedMapping="finishedTargetMapping" :rowMappingObjectStart="targetMappingObject" :modeStart="selectedMode"
            @backFromStep1="handleBackFromStep1" />

        </b-col>
      </b-row>
    </div>
    <div v-if="csvColumns.length > 0">
      <div class="step2">
        <IdentifierMapping v-if="currentStep === 2" :csvColumns="csvColumns"
          :finishedMapping="finishedIdentifierMapping" :identifierMappingObject="identifierMappingObject"
          :preSelectedOption="selectedIdentifierOption" @backFromStep2="handleBackFromStep1" :wineSupplierNotFound="wineSupplierNotFound" :useSearch="useSearch" />
      </div>

      <b-row class="mt-3" v-if="currentStep === 3">
        <b-col>
          <div v-if="isImporting">
            
            <h2>{{ infoText }}</h2>
          </div>
          <div v-else>
            <h2>Überprüfung der Liste abgeschlossen.</h2>
            <div class=" mt-4 mb-4">
              <b-alert variant="warning" :show="true" class="updater"> {{ notFoundWines.length }} Weine wurden nicht
                gefunden</b-alert>
              <b-alert :show="true" class="updater"> {{ foundWinesCount }} Weine wurden gefunden</b-alert>
            </div>
            
            <b-row v-if="matchingWines.length > 0" class="">
              <b-col>
                <h4>
                  Gefundene Produkte
                </h4>
                <b-row>
                  <b-col>
                    <h3>CSV Wein</h3>
                  </b-col>
                  <b-col cols="1"></b-col>
                  <b-col>
                    <h3>Produkt aus Datenbank</h3>
                  </b-col>
                  <b-col cols="1">
                    <h3>Glasweise</h3>
                  </b-col>
                  <b-col cols="1">
                    <h3>Übernehmen</h3>
                  </b-col>
                  <b-col cols="1">
                  </b-col>
                  
                </b-row>
                <b-row v-for="(wine, index) in matchingWines" :key="index">
                  <b-col>{{ wine.vineFromSheet }}</b-col>
                  <b-col cols="1"> ------- > </b-col>
                  <b-col>{{ wine.vineFromVenue }}</b-col>
                  <b-col cols="1"><button
                      :class="glasWines.indexOf(wine.row) < 0 ? 'inlineRow remove' : 'inlineRow accept'"
                      @click="addOrRemoveRowFromGlaswines(wine.row)"></button></b-col>
                  <b-col cols="1"><button
                      :class="excludeRowsFromUpdate.indexOf(wine.row) > -1 ? 'inlineRow cancel' : 'inlineRow accept'"
                      @click="addOrRemoveRowFromExludes(wine.row, wine.vineFromSheet)"></button></b-col>
                  <b-col cols="1">
                     <DuplicateIcon v-if="wine.isDuplicate" width="16" height="16" />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row v-if="notFoundWines.length > 0" class="mt-2">
              <b-col>
                <h4>
                  Nicht gefundene Produkte
                </h4>
              </b-col>
            </b-row>

            <b-row v-if="notFoundWines.length > 0" class="mt-2 stripedTable">
              <b-col>
                <b-table sticky-header="250px" :items="notFoundWines" :fields="notFoundListColumnsToShow">
                </b-table>
                <b-button size="sm" class="mb-3" @click="exportCSV()">Als CSV exportieren:</b-button>

              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <h4>Datum der Aktualisierung setzen:</h4>
                {{ importDate }}
                <b-form-datepicker class="mt-3 mb-3" :locale="$i18n.locale" id="fromDatePicker"
                  v-model="importDate"></b-form-datepicker>
                <ButtonFooter class="mt-3 mb-3" :backButtonVisible="true" :okButtonDisabled="false"
                  :backButtonLabel="this.$t('general.buttons.back')" :okButtonLabel="this.$t('updater.updateWines')"
                  :okAction="() => { startRealUpdate() }" :backAction="handleBackFromStep1" />
              </b-col>
            </b-row>
          </div>
        </b-col>

      </b-row>
      <b-row class="mt-3" v-if="currentStep === 4">
        <b-col>
          <h2>Update läuft</h2>
          <p>{{ infoText }}</p>
          aktuelle Zeile: {{ currentRow }} / {{ csvInput.length }}
        </b-col>
      </b-row>
      <b-row v-if="currentStep === 4" class="mt-3 stripedTable">
        <b-col>
          <b-alert v-if="currentRow == csvInput.length" variant="success" :show="true" class="updater">Update erfolgreich abgeschlossen</b-alert>
          <b-table sticky-header="500px" :items="finishedWines" :fields="finishedColumnsToShow" style="height: ">
          </b-table>

          <h3>Fehler:</h3>
           <b-table sticky-header="500px" :items="errorWines" :fields="notFoundListColumnsToShow" style="height: ">
          </b-table>
        </b-col>
      </b-row>
      
    </div>

    <b-row v-if="csvError.length > 0">
      <b-col>

        <h4 class="alert-heading">Fehler beim Einlesen der CSV Datei</h4>
        <p>
          {{ csvError }}
        </p>

      </b-col>
    </b-row>
    
  </div>
</template>
<script>
import DataService from "@/services/StrapiService.js";

import TargetMapping from "@/components/updater/TargetMapping.vue";
import IdentifierMapping from "@/components/updater/IdentifierMapping.vue";
import { read, utils } from 'xlsx';
import StepNavigation from "@/components/modals/addWine/StepNavigation.vue";
import ButtonFooter from "@/components/modals/ButtonFooter.vue";
import { fixCSVRowAfterMapping } from "@/utils/updaterHelper.js";
import { similarityBetween } from "../utils/findFunctions.js";
import { mapGetters } from "vuex";
import DuplicateIcon from "@/components/icons/DuplicateIcon.vue";
import { SSE } from "../../libs/sse.js";



export default {
  name: "UpdateAmounts",
  components: {
    TargetMapping,
    IdentifierMapping,
    StepNavigation,
    ButtonFooter,
    DuplicateIcon
  },
  data() {
    return {
      currentStep: 0,
      showAlert: false,
      stepTitles: [this.$t('updater.step0'), this.$t('updater.step1'), this.$t('updater.step2'), this.$t('updater.step3')],
      wineSupplierNotFound: [],
      csvColumns: [],
      offlineWineSupplierList: [],
      csvInput: [],
      csvError: [],
      targetMappingObject: {},

      selectedMode: null,
      identifierMappingObject: {},
     
      finishedColumnsToShow: [
        'Produkt',
        'Aenderung',
        'Vorher Flasche',
        'Vorher Glas',
        'Nachher Flasche',
        'Nachher Glas'
      ],
      finishedWines: [],
      fileName: '',
      file: null,
      selectedIdentifierOption: 'AI',
      currentRow: 0,
      foundWinesCount: 0,
      createdWinesCount: 0,
      matchingWines: [],
      notFoundWines: [],
      notFoundListColumnsToShow: [
        'Produkt',
        'Grund'
      ],
      isImporting: false,
      importDate: new Date(Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate())),
      dateDidChange: false,
      excludeRowsFromUpdate: [],
      glasWines: [],
      infoText: '',
      offlineVenueWine: [],
      offlineWines: [],
      sammellieferant: {},
      errorWines: [],
      eventSource: null,
      body: {},
      useSearch: true,
    }
  },
  async created() {
    const wineSupplierResponse = await DataService.getAllWineSuppliers(
      this.getVenue.id
    );
    this.offlineWineSupplierList = wineSupplierResponse["data"].data;
    
            // use sammellieferant
    this.sammellieferant = this.offlineWineSupplierList.find((wineSupplier) => {
      return wineSupplier.attributes.title === 'Sammellieferant' && wineSupplier.attributes.isGeneral === true; 
    });
    var header ={
        headers: {
          'Content-Type': 'text/event-stream',
          'Accept': 'text/event-stream',
          'Cache-Control': 'no-cache',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': 'Bearer ' + this.$store.getters.getJwt
        }
      }
      var server = DataService.getServerUrl();

      const self = this;
      this.eventSource = new SSE(server + '/updater/start?filters[venue]=' + this.$store.getters.getVenue.id, {
        headers:  header.headers,
        payload: JSON.stringify(this.body),
        method: "POST",
        start: false
      });
      this.eventSource.addEventListener("error", function (e) {
        self.infoText = "Es ist ein Fehler aufgetreten: " + e.data
      });
      this.eventSource.addEventListener("info", function (e) {
        self.infoText = e.data;
      });
      this.eventSource.addEventListener("matchingWines", function (e) {
        var parsedData = JSON.parse(e.data);
        self.matchingWines.push(parsedData);
        self.foundWinesCount = self.foundWinesCount + 1;
      });
      this.eventSource.addEventListener("notFoundWines", function (e) {
        var parsedData = JSON.parse(e.data);
        self.notFoundWines.push(parsedData);
        self.excludeRowsFromUpdate.push(parsedData.Zeile);
      });
      this.eventSource.addEventListener("glasWines", function (e) {
        var parsedData = JSON.parse(e.data);
        self.glasWines.push(parsedData);
      });
      this.eventSource.addEventListener("currentRow", function (e) {
        self.currentRow = parseInt(e.data);
      });
      this.eventSource.addEventListener("finishedWines", function (e) {
        var parsedData = JSON.parse(e.data);
        self.finishedWines.push(parsedData);
      });
      this.eventSource.addEventListener("errorWines", function (e) {
        var parsedData = JSON.parse(e.data);
        self.errorWines.push(parsedData);
      });
          
  },
  methods: {
    handleBackFromStep1() {
      this.currentStep = this.currentStep - 1;
      if (this.currentStep === 2) {
        this.notFoundWines = [];
        this.matchingWines = [];
        this.foundWinesCount = 0;
      }
    },
    
    async readFile(event) {
      this.file = event.target.files[0];
      this.fileName = this.file.name;

      if (this.file.name.endsWith('.xlsx')) {
        await this.readExcel();
        this.showAlert = true;
      } else if (this.file.name.endsWith('.csv')) {
        this.readCSV(false);
        this.showAlert = true;
      } else {
        console.log('Die Datei ist keine .xlsx oder .csv Datei');
        return;
      }
    },
    async readExcel() {
      const ab = await this.file.arrayBuffer();
      const wb = read(ab);
      const xlsxRows = utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
      const xlsxColumns = Object.keys(xlsxRows[0]);
      this.csvColumns = xlsxColumns
      this.csvInput = xlsxRows;
    },
    readCSV(afterTargetMapping) {
      console.log(this.file, 'file')
      const self = this;
      var csvinput = [];
      var csverror = [];
      var count = 0;
      
      this.$papa.parse(self.file, {
        //worker: true, // Don't bog down the main thread if its a big file
        header: true,
        download: true,
        skipEmptyLines: true,
        transformHeader: function (h) {
          return h.trim();
        },
        step: function (result) {
          // do stuff with result
          count = count + 1;
          if (result.errors.length == 0) {
          
            // clean up data
            if (afterTargetMapping)
            {
              if (self.targetMappingObject['Bezugsquelle'] != null){
                 var bezugsquelle = result.data[self.targetMappingObject['Bezugsquelle']];
                if (bezugsquelle != null && self.offlineWineSupplierList.indexOf(bezugsquelle) == -1 && self.wineSupplierNotFound.indexOf(bezugsquelle) == -1) {
                // check against the offlineWineSupplierList
                  const wineSupplier = self.offlineWineSupplierList.find((wineSupplier) => {
                  if (!wineSupplier.attributes || !wineSupplier.attributes.title) {
                    return false;
                  }
                  return similarityBetween(wineSupplier.attributes.title, bezugsquelle) > 0.7;
                });
                if (!wineSupplier) {
                    self.wineSupplierNotFound.push(bezugsquelle);
                  } else {
                    result.data[self.targetMappingObject['Bezugsquelle']] = wineSupplier.attributes.title;
                  }
                }
              }
              result.data.rowIndex = count;
              result.data = fixCSVRowAfterMapping(result.data, self.targetMappingObject);
            }
            
            csvinput.push(result.data);
          } else {
            csverror.push(result.errors[0]);
          }
        },
        complete: function () {
          self.csvError = csverror;
          self.csvInput = csvinput;
          self.csvColumns = Object.keys(csvinput[0]);
        },
      });
    },
    generateStream(onlyTemporarily)  {
      this.body = {
        identifierMappingObject: this.identifierMappingObject,
        targetMappingObject: this.targetMappingObject,
        csvWines: this.csvInput,
        excludeRowsFromUpdate: this.excludeRowsFromUpdate,
        onlyTemporarily: onlyTemporarily,
        selectedMode: this.selectedMode,
        importDate: this.importDate,
        venueId: this.$store.getters.getVenue.id,
        glasWines: this.glasWines,
        useSearch: this.useSearch
      }
      this.eventSource.payload = JSON.stringify(this.body);
      this.currentRow = 0;
      this.eventSource.stream();
    },

    finishedTargetMapping(targetMappingObject, mode) {
      this.readCSV(true);
      this.targetMappingObject = targetMappingObject;
      this.currentStep = this.currentStep + 1;
      this.selectedMode = mode
    },
    finishedIdentifierMapping(identifierMappingObject, selectedIdentifierOption, useInnerSearch) {
      this.identifierMappingObject = identifierMappingObject;
      this.selectedIdentifierOption = selectedIdentifierOption;
      this.currentStep = this.currentStep + 1;
      this.useSearch = useInnerSearch;
      this.generateStream(true);
      
      // this.updateVenueWines(true);
      console.log('finished');

    },
  
    exportCSV() {
      var csv = this.$papa.unparse(this.notFoundWines);
      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      var link = document.createElement("a");
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "notFoundWines.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    startRealUpdate() {
      this.generateStream(false);
      this.currentStep = 4;
    },
    addOrRemoveRowFromExludes(row, wineName) {
      var index = this.excludeRowsFromUpdate.indexOf(row);
      if (index > -1) {
        // TODO remove from notFoundWines
        this.excludeRowsFromUpdate.splice(index, 1);
        this.notFoundWines = this.notFoundWines.filter((wine) => {
          return wine['Produkt'] !== wineName && wine['Grund'] !== 'Manuell ausgeschlossen';
        });
      } else {
        const notFoundWine = {
          Produkt: wineName,
          Zeile: row,
          Grund: 'Manuell ausgeschlossen'
        }
        
        this.notFoundWines.push(notFoundWine)
        this.excludeRowsFromUpdate.push(row);
      }
    },
    addOrRemoveRowFromGlaswines(row) {
      console.log('addOrRemoveRowFromGlaswines', row)
      var index = this.glasWines.indexOf(row);
      if (index > -1) {
        this.glasWines.splice(index, 1);
      } else {
        this.glasWines.push(row);
      }
    },
    couldBeGlassWine(wineFromSheet) {
      return wineFromSheet.Produkt.includes('0,1') || wineFromSheet.Produkt.includes('0,2') || wineFromSheet['Flaschengröße'] == 0.1 || wineFromSheet['Flaschengröße'] == 0.2;
    },
    scrollToBottom() {
      var mainContainer = document.getElementsByClassName('mainContainer')[0];
      if (mainContainer) {
        mainContainer.scrollTo(0, mainContainer.scrollHeight, 'smooth');
      }
    }
  },
  watch: {
    importDate: function () {
      this.dateDidChange = true;
    }
  },
  computed: {
    ...mapGetters(['getVenue']),
  }
};
</script>
<style scoped>
.scroll-down-btn {
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 100;
  background-color: var(--color-primary-500);
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.scroll-down-btn svg {
  width: 24px;
  height: 24px;
}
</style>